import React, { useEffect, useState } from "react";
import "./createpremiumprojects.scss";
import Basicinfo from "./Basicinfo";
import Media from "./Media";
import Team from "./Team";
import Modal from "react-bootstrap/Modal";
import Socials from "./Socials";
import Salerounds from "./Salerounds";
import Wallets from "./Wallets";
import Nft from "./Nft";
import Summary from "./Summary";
import { ProgressBar } from "react-bootstrap";
import Bottompage from "./Bottompage";
import { Link } from "react-router-dom";
import PreviewProject from "../PreviewProject/PreviewProject";
import Loader from "../../../../hooks/loader";
import { ethers } from "ethers";
import axios from "axios";
import { Api_Url } from "../../../../utils/ApiUrl";
import UseAutomateProject from "../../../../hooks/dataSenders/automateProject";
import { useWeb3React } from "@web3-react/core";
import { toast } from "react-toastify";

const Createpremiumprojects = ({ setRoutes, setId }) => {
  // integration states
  console.log("deployed");
  const [loader, setLoader] = useState(false);
  const [projectId, setProjectId] = useState(null);
  const { createLaunchpad } = UseAutomateProject();
  const [lastUpdated, setLastUpdated] = useState(false);
  const { account } = useWeb3React();
  const [isLive, setIsLive] = useState(false);
  const [isAvailable, setIsAvailable] = useState(null);
  const [basicInfo, setBasicInfo] = useState({
    projectName: {
      value: "",
      error: false,
      errorMsg: "",
    },
    projectTicker: {
      value: "",
      error: false,
      errorMsg: "",
    },
    shortDescription: {
      value: "",
      error: false,
      errorMsg: "",
    },
    details: {
      value: "",
      error: false,
      errorMsg: "",
    },
  });
  const [projectSetup, setProjectSetup] = useState({
    projectImage: {
      value: null, // File or URL
      error: false,
      errorMsg: "",
    },

    projectBannerDesktop: {
      value: null, // File or URL
      error: false,
      errorMsg: "",
    },

    projectBannerMobile: {
      value: null, // File or URL
      error: false,
      errorMsg: "",
    },

    tokenomicsChartDark: {
      value: null, // File or URL
      error: false,
      errorMsg: "",
    },

    tokenomicsChartLight: {
      value: null, // File or URL
      error: false,
      errorMsg: "",
    },

    projectMedia: {
      value: [], // array of files (image/video)
      file: [],
      error: false,
      errorMsg: "",
    },

    youtubeEmbeds: {
      value: [""], // dynamic list of URLs
      error: false,
      errorMsg: "",
    },

    documents: {
      value: [
        {
          name: "",
          file: null,
        },
      ],
      error: false,
      errorMsg: "",
    },
  });
  const [youtubeErrors, setYoutubeErrors] = useState({
    errors: [false], // Track error for each link by index
    errorMsgs: [""], // Track error message for each link by index
  });
  const [teamFormData, setTeamFormData] = useState({
    team: [{ image: null, name: "", designation: "", bio: "" }],
  });

  const [teamFormErrors, setTeamFormErrors] = useState({
    team: [], // Array of error objects for each team member
  });

  const [socialsFormData, setSocialsFormData] = useState({
    projectWebsite: "",
    projectTwitter: "",
    projectTelegram: "",
    projectMedium: "",
    projectYoutube: "",
    projectDiscord: "",
    projectLinkedIn: "",
  });

  const [socialsFormErrors, setSocialsFormErrors] = useState({
    projectWebsite: "",
    projectTwitter: "",
    projectTelegram: "",
    projectMedium: "",
    projectYoutube: "",
    projectDiscord: "",
    projectLinkedIn: "",
  });
  const [saleRounds, setSaleRounds] = useState([
    {
      roundNumber: 1,
      roundPrice: 0,
      startDate: "",
      enddate: "",
    },
  ]);
  const [saleRoundsErrors, setSaleRoundsErrors] = useState([
    {
      roundNumber: "",
      roundPrice: "",
      startDate: "",
      enddate: "",
    },
  ]);
  const [walletformData, setWalletFormData] = useState({
    projectFundWallet: "",
    platformFeeWallet: "",
    ownerWallet: "",
    buybackBurnWallet: "",
    acceptedPaymentTokens: [],
    platformFeeThreshold: "",
    initialPlatformAmount: "",
  });
  const [tokens, setTokens] = useState([]);

  const [walletFormErrors, setWalletFormErrors] = useState({
    projectFundWallet: "",
    platformFeeWallet: "",
    ownerWallet: "",
    acceptedPaymentTokens: "",
    platformFeeThreshold: "",
    initialPlatformAmount: "",
  });

  const [nftFormData, setNftFormData] = useState({
    nftRequired: false,
    nftDetails: [],
    buyBackRequired: false,
    buyBackDetails: [],
  });

  const [nftFormErrors, setNftFormErrors] = useState({
    nftDetails: "",
    buyBackDetails: "",
  });

  // integration states end

  //
  // ✅ FIXED: Keys now match the projectSetup state keys exactly
  const errorMessages = {
    projectName: "Project name is mandatory",
    projectTicker: "Project ticker is mandatory",
    shortDescription: "Short description is mandatory",
    details: "Project details are mandatory",
    projectImage: "Project image is mandatory",
    projectBannerDesktop: "Project Banner (Desktop) is mandatory",
    projectBannerMobile: "Project Banner (Mobile) is mandatory",
    documents: "Documents are mandatory",
  };

  const validateBasicInfo = async () => {
    const validated = Object.entries(basicInfo).reduce((acc, [key, field]) => {
      let value = field.value;

      if (typeof value === "string") {
        value = value
          .replace(/<[^>]*>/g, "")
          .replace(/&nbsp;/g, "")
          .trim();
      }

      const isEmpty =
        value === null ||
        value === undefined ||
        value === "" ||
        (Array.isArray(value) && value.length === 0);

      acc[key] = {
        ...field,
        error: isEmpty,
        errorMsg: isEmpty ? errorMessages[key] : "",
      };

      return acc;
    }, {});

    // Check if ticker is already taken ONLY if it's a new project or ticker has changed
    if (validated.projectTicker && !validated.projectTicker.error) {
      const ticker = validated.projectTicker.value;

      // Get original ticker from localStorage if editing
      const storedProjectId = localStorage.getItem("draftProjectId");
      const isEditingExistingProject = projectId || storedProjectId;

      // Only validate if:
      // 1. Creating new project (no projectId), OR
      // 2. Editing and ticker has changed
      if (isAvailable === false) {
        validated.projectTicker = {
          ...validated.projectTicker,
          error: true,
          errorMsg: "This ticker is already taken",
        };
      }
    }

    setBasicInfo(validated);

    return !Object.values(validated).some((field) => field.error);
  };

  // YouTube URL validator helper
  const isValidYoutubeUrl = (url) => {
    if (!url || url.trim() === "") return true; // Empty is valid (not required)

    const youtubePatterns = [
      // Standard watch URL: https://www.youtube.com/watch?v=VIDEO_ID
      /^https?:\/\/(www\.)?youtube\.com\/watch\?v=[\w-]+(&.*)?$/,

      // Short URL: https://youtu.be/VIDEO_ID
      /^https?:\/\/youtu\.be\/[\w-]+(\?.*)?$/,

      // Embed URL: https://www.youtube.com/embed/VIDEO_ID
      /^https?:\/\/(www\.)?youtube\.com\/embed\/[\w-]+(\?.*)?$/,

      // Mobile URL: https://m.youtube.com/watch?v=VIDEO_ID
      /^https?:\/\/m\.youtube\.com\/watch\?v=[\w-]+(&.*)?$/,

      // Shorts URL: https://www.youtube.com/shorts/VIDEO_ID
      /^https?:\/\/(www\.)?youtube\.com\/shorts\/[\w-]+(\?.*)?$/,
    ];

    return youtubePatterns.some((pattern) => pattern.test(url));
  };

  const validateProjectSetup = () => {
    const requiredKeys = [
      "projectImage",
      "projectBannerDesktop",
      "projectBannerMobile",
      "documents",
    ];

    const validated = Object.entries(projectSetup).reduce(
      (acc, [key, field]) => {
        // Special case: YouTube embeds validation
        if (key === "youtubeEmbeds") {
          const errors = [];
          const errorMsgs = [];
          let hasAnyError = false;

          field.value.forEach((url, index) => {
            const trimmedUrl = url.trim();
            const isValid = isValidYoutubeUrl(trimmedUrl);
            const hasError = !isValid && trimmedUrl !== "";

            errors[index] = hasError;
            errorMsgs[index] = hasError ? "Invalid YouTube URL format's" : "";

            if (hasError) hasAnyError = true;
          });

          setYoutubeErrors({
            errors: errors,
            errorMsgs: errorMsgs,
          });

          acc[key] = {
            ...field,
            error: hasAnyError,
            errorMsg: "",
          };
          return acc;
        }

        // Only validate required fields
        if (!requiredKeys.includes(key)) {
          acc[key] = field;
          return acc;
        }

        let isEmpty = false;
        let customErrorMsg = "";

        // Special case: documents - comprehensive validation
        if (key === "documents") {
          // Check if we have valid documents array
          if (!Array.isArray(field.value) || field.value.length === 0) {
            isEmpty = true;
            customErrorMsg = "Documents are mandatory";
          } else {
            // ✅ NEW: Check if ALL documents are complete (both name and file)
            // This means NO document can be empty or partial
            const allDocumentsComplete = field.value.every((doc) => {
              const hasName = doc.name && doc.name.trim() !== "";
              const hasFile = doc.file && doc.file !== null;
              return hasName && hasFile;
            });

            // Find specific issues to provide better error messages
            const hasNameWithoutFile = field.value.some(
              (doc) =>
                doc.name &&
                doc.name.trim() !== "" &&
                (!doc.file || doc.file === null)
            );

            const hasFileWithoutName = field.value.some(
              (doc) =>
                doc.file &&
                doc.file !== null &&
                (!doc.name || doc.name.trim() === "")
            );

            const hasCompletelyEmptyRow = field.value.some(
              (doc) =>
                (!doc.name || doc.name.trim() === "") &&
                (!doc.file || doc.file === null)
            );

            // ✅ If not all documents are complete, block and show appropriate error
            if (!allDocumentsComplete) {
              isEmpty = true;

              // Prioritize error messages
              if (hasCompletelyEmptyRow) {
                customErrorMsg =
                  "Please remove empty document rows or fill them completely";
              } else if (hasNameWithoutFile) {
                customErrorMsg = "Please upload a file for each document name";
              } else if (hasFileWithoutName) {
                customErrorMsg = "Document names are necessary";
              } else {
                customErrorMsg = "All documents must have both a name and file";
              }
            }
          }
        } else {
          isEmpty =
            field.value === null ||
            field.value === undefined ||
            field.value.toString?.().trim() === "";
          customErrorMsg = errorMessages[key];
        }

        acc[key] = {
          ...field,
          error: isEmpty,
          errorMsg: isEmpty ? customErrorMsg : "",
        };

        return acc;
      },
      {}
    );

    setProjectSetup(validated);

    const hasErrors = Object.values(validated).some((field) => field.error);
    return !hasErrors;
  };

  const validateTeamForm = () => {
    const teamErrors = [];
    let hasError = false;

    teamFormData.team.forEach((member, index) => {
      const memberErrors = {};

      // Check if member has ANY data filled
      const hasAnyData =
        member.name.trim() !== "" ||
        member.designation.trim() !== "" ||
        member.bio.trim() !== "" ||
        member.image !== null;

      // If member has any data, validate all required fields (except image)
      if (hasAnyData) {
        if (!member.name || member.name.trim() === "") {
          memberErrors.name = "Full name is required when team member is added";
          hasError = true;
        }

        if (!member.designation || member.designation.trim() === "") {
          memberErrors.designation =
            "Designation is required when team member is added";
          hasError = true;
        }

        if (!member.bio || member.bio.trim() === "") {
          memberErrors.bio = "Bio is required when team member is added";
          hasError = true;
        }
      }

      teamErrors[index] = memberErrors;
    });

    setTeamFormErrors({
      team: teamErrors,
    });

    return !hasError;
  };

  const validateSaleRounds = () => {
    const roundsErrors = [];
    let hasError = false;

    // If no sale rounds, validation passes (optional field)
    if (saleRounds.length === 0) {
      return true;
    }

    saleRounds.forEach((round, index) => {
      const roundErrors = {};

      // Round Number validation
      if (!round.roundNumber || round.roundNumber <= 0) {
        roundErrors.roundNumber = "Round number is required";
        hasError = true;
      }

      // Round Price validation
      if (
        round.roundPrice === "" ||
        round.roundPrice === null ||
        round.roundPrice === undefined ||
        round.roundPrice === 0
      ) {
        roundErrors.roundPrice = "Round price is required";
        hasError = true;
      } else if (
        isNaN(parseFloat(round.roundPrice)) ||
        parseFloat(round.roundPrice) <= 0
      ) {
        roundErrors.roundPrice = "Round price must be greater than 0";
        hasError = true;
      }
      // ✅ NEW: Check if current round price is greater than ALL previous round prices
      else if (index > 0) {
        const currentPrice = parseFloat(round.roundPrice);

        // Find the highest price from all previous rounds
        let highestPreviousPrice = -Infinity;
        let highestPriceRoundNumber = 0;

        for (let i = 0; i < index; i++) {
          const prevPrice = parseFloat(saleRounds[i].roundPrice);
          if (!isNaN(prevPrice) && prevPrice > highestPreviousPrice) {
            highestPreviousPrice = prevPrice;
            highestPriceRoundNumber = i + 1;
          }
        }

        if (currentPrice < highestPreviousPrice) {
          roundErrors.roundPrice = `Round ${
            index + 1
          } price must be greater than Round ${highestPriceRoundNumber} price (${highestPreviousPrice})`;
          hasError = true;
        }
      }

      // Start Date validation
      if (!round.startDate || round.startDate.trim() === "") {
        roundErrors.startDate = "Start date is required";
        hasError = true;
      } else {
        const startDate = new Date(round.startDate);
        const now = new Date();

        if (isNaN(startDate.getTime())) {
          roundErrors.startDate = "Invalid date format";
          hasError = true;
        } else {
          // Check if start date/time is in the past (including today's earlier times)
          if (startDate <= now) {
            roundErrors.startDate = "Start date and time must be in the future";
            hasError = true;
          }
          // Check if this round's start date is after previous round's end date
          else if (index > 0) {
            const prevRound = saleRounds[index - 1];
            if (prevRound.enddate && prevRound.enddate.trim() !== "") {
              const prevEndDate = new Date(prevRound.enddate);
              if (!isNaN(prevEndDate.getTime()) && startDate < prevEndDate) {
                roundErrors.startDate = `Round ${
                  index + 1
                } start date must be after Round ${index} end date`;
                hasError = true;
              }
            }
          }
        }
      }

      // End Date validation
      if (!round.enddate || round.enddate.trim() === "") {
        roundErrors.enddate = "End date is required";
        hasError = true;
      } else {
        const enddate = new Date(round.enddate);
        if (isNaN(enddate.getTime())) {
          roundErrors.enddate = "Invalid date format";
          hasError = true;
        } else {
          // Check if end date is after start date
          if (round.startDate && !roundErrors.startDate) {
            const startDate = new Date(round.startDate);
            if (enddate <= startDate) {
              roundErrors.enddate = "End date must be after start date";
              hasError = true;
            }
          }
        }
      }

      roundsErrors[index] = roundErrors;
    });

    setSaleRoundsErrors(roundsErrors);
    return !hasError;
  };

  // URL validators
  const isValidUrl = (url) => {
    if (!url || url.trim() === "") return true;
    try {
      const urlObj = new URL(url);
      // Accept http or https, and ensure there's a valid hostname
      return (
        (urlObj.protocol === "http:" || urlObj.protocol === "https:") &&
        urlObj.hostname.length > 0
      );
    } catch {
      return false;
    }
  };

  const isValidTwitter = (url) => {
    if (!url || url.trim() === "") return true;
    const twitterPatterns = [
      /^https?:\/\/(www\.)?(twitter\.com|x\.com)\/[\w]+\/?$/,
      /^https?:\/\/(www\.)?(twitter\.com|x\.com)\/[\w]+(\?.*)?$/,
    ];
    return twitterPatterns.some((pattern) => pattern.test(url.trim()));
  };

  const isValidTelegram = (url) => {
    if (!url || url.trim() === "") return true;
    const telegramPatterns = [
      // t.me/username or telegram.me/username
      /^https?:\/\/(www\.)?(t\.me|telegram\.me)\/[\w]+\/?$/,
      // t.me/+inviteCode (note the + sign for invite links)
      /^https?:\/\/(www\.)?t\.me\/\+[\w-]+\/?$/,
    ];
    return telegramPatterns.some((pattern) => pattern.test(url.trim()));
  };

  const isValidMedium = (url) => {
    if (!url || url.trim() === "") return true;
    const mediumPatterns = [
      // medium.com/@username
      /^https?:\/\/(www\.)?medium\.com\/@[\w-]+\/?$/,
      // medium.com/publication-name
      /^https?:\/\/(www\.)?medium\.com\/[\w-]+\/?$/,
      // username.medium.com (subdomain format)
      /^https?:\/\/[\w-]+\.medium\.com\/?$/,
    ];
    return mediumPatterns.some((pattern) => pattern.test(url.trim()));
  };

  const isValidYoutube = (url) => {
    if (!url || url.trim() === "") return true;
    const youtubePatterns = [
      // @channel format: https://www.youtube.com/@channelname
      /^https?:\/\/(www\.)?youtube\.com\/@[\w-]+(\?.*)?$/,
      // Channel ID: https://www.youtube.com/channel/CHANNEL_ID
      /^https?:\/\/(www\.)?youtube\.com\/channel\/[\w-]+(\?.*)?$/,
      // Watch URL: https://www.youtube.com/watch?v=VIDEO_ID
      /^https?:\/\/(www\.)?youtube\.com\/watch\?v=[\w-]+(&.*)?$/,
      // Short URL: https://youtu.be/VIDEO_ID
      /^https?:\/\/youtu\.be\/[\w-]+(\?.*)?$/,
      // User: https://www.youtube.com/user/username
      /^https?:\/\/(www\.)?youtube\.com\/user\/[\w-]+(\?.*)?$/,
      // C/ format: https://www.youtube.com/c/channelname
      /^https?:\/\/(www\.)?youtube\.com\/c\/[\w-]+(\?.*)?$/,
      // Direct channel name: https://www.youtube.com/channelname
      /^https?:\/\/(www\.)?youtube\.com\/[\w-]+(\?.*)?$/,
    ];
    return youtubePatterns.some((pattern) => pattern.test(url.trim()));
  };

  const isValidDiscord = (url) => {
    if (!url || url.trim() === "") return true;
    const discordPatterns = [
      // discord.gg/inviteCode
      /^https?:\/\/(www\.)?discord\.gg\/[\w-]+\/?$/,
      // discord.com/invite/inviteCode
      /^https?:\/\/(www\.)?discord\.com\/invite\/[\w-]+\/?$/,
    ];
    return discordPatterns.some((pattern) => pattern.test(url.trim()));
  };

  const isValidLinkedIn = (url) => {
    if (!url || url.trim() === "") return true;
    const linkedinPatterns = [
      // Company page: https://www.linkedin.com/company/company-name
      /^https?:\/\/(www\.)?linkedin\.com\/company\/[\w-]+\/?$/,
      // Personal profile: https://www.linkedin.com/in/username
      /^https?:\/\/(www\.)?linkedin\.com\/in\/[\w-]+\/?$/,
    ];
    return linkedinPatterns.some((pattern) => pattern.test(url.trim()));
  };

  const validateSocialsForm = () => {
    const newErrors = {};

    // Project Website is REQUIRED
    if (
      !socialsFormData.projectWebsite ||
      socialsFormData.projectWebsite.trim() === ""
    ) {
      newErrors.projectWebsite = "Project website is required";
    } else if (!isValidUrl(socialsFormData.projectWebsite)) {
      newErrors.projectWebsite =
        "Please enter a valid URL (e.g., https://example.com)";
    }

    // Twitter - Optional but must be valid if provided
    if (
      socialsFormData.projectTwitter &&
      !isValidTwitter(socialsFormData.projectTwitter)
    ) {
      newErrors.projectTwitter =
        "Please enter a valid Twitter/X URL (e.g., https://twitter.com/username or https://x.com/username)";
    }

    // Telegram - Optional but must be valid if provided
    if (
      socialsFormData.projectTelegram &&
      !isValidTelegram(socialsFormData.projectTelegram)
    ) {
      newErrors.projectTelegram =
        "Please enter a valid Telegram URL (e.g., https://t.me/username)";
    }

    // Medium - Optional but must be valid if provided
    if (
      socialsFormData.projectMedium &&
      !isValidMedium(socialsFormData.projectMedium)
    ) {
      newErrors.projectMedium =
        "Please enter a valid Medium URL (e.g., https://medium.com/@username)";
    }

    // Youtube - Optional but must be valid if provided
    if (
      socialsFormData.projectYoutube &&
      !isValidYoutube(socialsFormData.projectYoutube)
    ) {
      newErrors.projectYoutube =
        "Please enter a valid YouTube URL (e.g., https://youtube.com/@channel)";
    }

    // Discord - Optional but must be valid if provided
    if (
      socialsFormData.projectDiscord &&
      !isValidDiscord(socialsFormData.projectDiscord)
    ) {
      newErrors.projectDiscord =
        "Please enter a valid Discord URL (e.g., https://discord.gg/inviteCode)";
    }

    // LinkedIn - Optional but must be valid if provided
    if (
      socialsFormData.projectLinkedIn &&
      !isValidLinkedIn(socialsFormData.projectLinkedIn)
    ) {
      newErrors.projectLinkedIn =
        "Please enter a valid LinkedIn URL (e.g., https://linkedin.com/company/name or https://linkedin.com/in/username)";
    }

    setSocialsFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateWalletForm = () => {
    const newErrors = {};

    // Helper function to validate Ethereum address
    const isValidEthereumAddress = (address) => {
      try {
        return ethers.utils.isAddress(address);
      } catch {
        return false;
      }
    };

    // Project Fund Wallet
    if (!walletformData.projectFundWallet) {
      newErrors.projectFundWallet = "Project's Funds Wallet is required";
    } else if (!isValidEthereumAddress(walletformData.projectFundWallet)) {
      newErrors.projectFundWallet = "Invalid Ethereum wallet address";
    }

    // Platform Fee Wallet
    if (!walletformData.platformFeeWallet) {
      newErrors.platformFeeWallet = "Platform Fee Wallet is required";
    } else if (!isValidEthereumAddress(walletformData.platformFeeWallet)) {
      newErrors.platformFeeWallet = "Invalid Ethereum wallet address";
    }

    // Owner Wallet
    if (!walletformData.ownerWallet) {
      newErrors.ownerWallet = "Owner's Wallet is required";
    } else if (!isValidEthereumAddress(walletformData.ownerWallet)) {
      newErrors.ownerWallet = "Invalid Ethereum wallet address";
    }

    // Buyback Burn Wallet
    // if (!walletformData.buybackBurnWallet) {
    //   newErrors.buybackBurnWallet = "Buyback & Burn Wallet is required";
    // } else if (!isValidEthereumAddress(walletformData.buybackBurnWallet)) {
    //   newErrors.buybackBurnWallet = "Invalid Ethereum wallet address";
    // }

    // Accepted Payment Tokens
    if (
      !walletformData.acceptedPaymentTokens ||
      walletformData.acceptedPaymentTokens.length === 0
    ) {
      newErrors.acceptedPaymentTokens =
        "Please select at least one payment token";
    }

    // Platform Fee Threshold
    if (walletformData.platformFeeThreshold) {
      const threshold = Number(walletformData.platformFeeThreshold);
      if (isNaN(threshold) || threshold < 0) {
        newErrors.platformFeeThreshold = "Must be a valid positive number";
      }
    }

    // Initial Platform Amount
    if (walletformData.initialPlatformAmount) {
      const amount = Number(walletformData.initialPlatformAmount);
      if (isNaN(amount) || amount < 0) {
        newErrors.initialPlatformAmount = "Must be a valid positive number";
      }
    }

    // ✅ NEW VALIDATION: Check if Initial Platform Amount > Platform Fee Threshold
    const initialAmount = Number(walletformData.initialPlatformAmount || 0);
    const threshold = Number(walletformData.platformFeeThreshold || 0);

    if (initialAmount > 0 && threshold > 0 && initialAmount > threshold) {
      newErrors.initialPlatformAmount =
        "Initial Platform Amount cannot be greater than Platform Fee Threshold";
    }

    setWalletFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateNftForm = () => {
    const newErrors = {};

    // If NFT is required, validate NFT details
    if (nftFormData.nftRequired) {
      if (nftFormData.nftDetails.length === 0) {
        newErrors.nftDetails = "Please add at least one NFT";
      } else {
        // Create an array to store errors for each NFT item
        const itemErrors = [];

        nftFormData.nftDetails.forEach((nft, index) => {
          const errors = {};

          if (!nft.image) {
            errors.image = "NFT image is required";
          }

          if (!nft.price || nft.price.toString().trim() === "") {
            errors.price = "NFT price is required";
          } else if (isNaN(nft.price) || Number(nft.price) <= 0) {
            errors.price = "Invalid or missing price";
          }

          if (Object.keys(errors).length > 0) {
            itemErrors[index] = errors;
          }
        });

        if (itemErrors.length > 0) {
          newErrors.nftDetailsItems = itemErrors;
        }
      }
    }

    setNftFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    console.log("Current Step:", currentStep);
    if (currentStep === 0) {
      const isValid = await validateBasicInfo();
      if (isValid) {
        setCurrentStep((prev) => prev + 1);
      }
    }
    if (currentStep === 1) {
      if (validateProjectSetup()) {
        setCurrentStep((prev) => prev + 1);
      }
    }
    if (currentStep === 2) {
      // ✅ NEW: Clean up empty team members before validation
      const cleanedTeam = teamFormData.team.filter((member) => {
        const hasAnyData =
          member.name.trim() !== "" ||
          member.designation.trim() !== "" ||
          member.bio.trim() !== "" ||
          member.image !== null;
        return hasAnyData;
      });

      // ✅ Update state with cleaned team data
      setTeamFormData((prev) => ({
        ...prev,
        team:
          cleanedTeam.length > 0
            ? cleanedTeam
            : [{ image: null, name: "", designation: "", bio: "" }], // Keep at least one empty member
      }));

      // ✅ Clear team errors since we're removing empty members
      setTeamFormErrors({
        team: [],
      });

      if (validateTeamForm()) {
        setCurrentStep((prev) => prev + 1);
      }
    }
    if (currentStep === 3) {
      if (validateSocialsForm()) {
        setCurrentStep((prev) => prev + 1);
      }
    }
    if (currentStep === 4) {
      if (validateSaleRounds()) {
        setCurrentStep((prev) => prev + 1);
      }
    }
    if (currentStep === 5) {
      const initialPlatformAmount = parseFloat(
        walletformData.initialPlatformAmount || "0"
      );
      const platformFeeThreshold = parseFloat(
        walletformData.platformFeeThreshold || "0"
      );

      if (initialPlatformAmount > 0 && platformFeeThreshold === 0) {
        setWalletFormErrors((prev) => ({
          ...prev,
          platformFeeThreshold:
            "Platform Fee Threshold is required when Initial Platform Amount is greater than 0",
        }));
        return;
      }

      if (validateWalletForm()) {
        setCurrentStep((prev) => prev + 1);
      }
    }
    if (currentStep === 6) {
      if (validateNftForm()) {
        setCurrentStep((prev) => prev + 1);
      }
    }
  };

  //

  const steps = [
    {
      title: "Basic Info",
      component: (
        <Basicinfo
          basicInfo={basicInfo}
          setBasicInfo={setBasicInfo}
          projectId={projectId}
          isAvailable={isAvailable}
          setIsAvailable={setIsAvailable}
        />
      ),
    },
    {
      title: "Media & Documents",
      component: (
        <Media
          projectSetup={projectSetup}
          setProjectSetup={setProjectSetup}
          projectId={projectId}
          setLoader={setLoader}
          youtubeErrors={youtubeErrors}
          setYoutubeErrors={setYoutubeErrors}
          isValidYoutubeUrl={isValidYoutubeUrl}
        />
      ),
    },
    {
      title: "Team",
      component: (
        <Team
          teamFormErrors={teamFormErrors}
          setTeamFormErrors={setTeamFormErrors}
          teamFormData={teamFormData}
          setTeamFormData={setTeamFormData}
          setLoader={setLoader}
        />
      ),
    },
    {
      title: "Socials",
      component: (
        <Socials
          socialsFormData={socialsFormData}
          setSocialsFormData={setSocialsFormData}
          socialsFormErrors={socialsFormErrors}
          setSocialsFormErrors={setSocialsFormErrors}
        />
      ),
    },
    {
      title: "Sale Rounds",
      component: (
        <Salerounds
          saleRounds={saleRounds}
          setSaleRounds={setSaleRounds}
          saleRoundsErrors={saleRoundsErrors}
          setSaleRoundsErrors={setSaleRoundsErrors}
        />
      ),
    },
    {
      title: "Wallets & Fees",
      component: (
        <Wallets
          walletFormErrors={walletFormErrors}
          setWalletFormErrors={setWalletFormErrors}
          walletformData={walletformData}
          setWalletFormData={setWalletFormData}
          tokens={tokens}
        />
      ),
    },
    {
      title: "NFT&Re-Buy",
      component: (
        <Nft
          nftFormData={nftFormData}
          setNftFormData={setNftFormData}
          nftFormErrors={nftFormErrors}
          setLoader={setLoader}
          setNftFormErrors={setNftFormErrors}
        />
      ),
    },
    {
      title: "Summary",
      component: (
        <Summary
          basicInfo={basicInfo}
          saleRounds={saleRounds}
          walletformData={walletformData}
          nftFormData={nftFormData}
          tokens={tokens}
        />
      ),
    },
  ];
  const [currentStep, setCurrentStep] = useState(0);
  const [show, setShow] = useState(false);
  const [isConnected, setIsConnected] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => {
    if (!account) {
      toast.info("Please connect your wallet to proceed");
      // setIsConnected("Wallet not connected");
      return 0;
    }
    // Validate Sale Rounds before publishing
    if (!validateSaleRounds()) {
      // Set currentStep to 4 (Sale Rounds step) to show the errors
      setCurrentStep(4);
      return; // Don't show the publish modal
    }
    setShow(true);
  };
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => {
    setId(null);
    setRoutes(false);
    setShow1(false);
  };
  const handleShow1 = () => setShow1(true);
  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const progressPercent = ((currentStep + 1) / steps.length) * 100;
  const [copied, setCopied] = useState(false);

  const [changeRoute, setChangeRoute] = useState(false);

  // Edit project flow
  useEffect(() => {
    let _id = localStorage?.getItem("draftProjectId");
    setProjectId(_id);
    if (_id) {
      setLoader(true);
      let token = localStorage.getItem("accessToken");
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${Api_Url}/pro-projects/${_id}/get`,
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      };
      axios
        .request(config)
        .then((response) => {
          if (response.data?.data) {
            if (response?.data?.data?.isLive) {
              setChangeRoute(true);
            }
            populateStatesFromAPI(response.data.data);
          }
          setCurrentStep(response?.data?.data?.stage - 1);
          localStorage?.removeItem("draftProjectId");
          setRoutes(false);
          setLoader(false);
        })
        .catch((error) => {
          console.log(error);
          setLoader(false);
        });
    }
  }, []);

  const populateStatesFromAPI = (apiData) => {
    // 1. Basic Info
    setBasicInfo({
      projectName: {
        value: apiData.projectName || "",
        error: false,
        errorMsg: "",
      },
      projectTicker: {
        value: apiData.projectTicker || "",
        error: false,
        errorMsg: "",
      },
      shortDescription: {
        value: apiData.projectShortDescription || "",
        error: false,
        errorMsg: "",
      },
      details: {
        value: apiData.projectDetails || "",
        error: false,
        errorMsg: "",
      },
    });

    // 2. Project Setup
    setProjectSetup({
      projectImage: {
        value: apiData.projectImage || null,
        error: false,
        errorMsg: "",
      },
      projectBannerDesktop: {
        value: apiData.projectBannerDesktop || null,
        error: false,
        errorMsg: "",
      },
      projectBannerMobile: {
        value: apiData.projectBannerMobile || null,
        error: false,
        errorMsg: "",
      },
      tokenomicsChartDark: {
        value: apiData.tokenomicsChartDark || null,
        error: false,
        errorMsg: "",
      },
      tokenomicsChartLight: {
        value: apiData.tokenomicsChartLight || null,
        error: false,
        errorMsg: "",
      },
      projectMedia: {
        value: apiData.projectMedia || [],
        file: apiData.projectMedia || [],
        error: false,
        errorMsg: "",
      },
      youtubeEmbeds: {
        value: apiData.youtubeEmbed?.length > 0 ? apiData.youtubeEmbed : [""],
        error: false,
        errorMsg: "",
      },
      documents: {
        value:
          apiData.projectDocument?.length > 0
            ? apiData.projectDocument.map((doc) => ({
                name: doc.title || "",
                file: doc.url || null,
                title: doc.title || "",
              }))
            : [{ name: "", file: null }],
        error: false,
        errorMsg: "",
      },
    });

    console.log({
      value:
        apiData.projectDocument?.length > 0
          ? apiData.projectDocument.map((doc) => ({
              name: doc.title || "",
              file: doc.url || null,
              title: doc.title || "",
            }))
          : [{ name: "", file: null }],
      error: false,
      errorMsg: "",
    });
    setLastUpdated(apiData.updatedAt);
    setIsLive(apiData.isLive);

    // 3. Team Data
    setTeamFormData({
      team:
        apiData.team?.length > 0
          ? apiData.team.map((member) => ({
              image: member.image || null,
              name: member.Name || member.name || "",
              designation: member.designation || "",
              bio: member.bio || "",
            }))
          : [{ image: null, name: "", designation: "", bio: "" }],
    });

    // 4. Socials Data
    setSocialsFormData({
      projectWebsite: apiData.projectWebsite || "",
      projectTwitter: apiData.projectTwitter || "",
      projectTelegram: apiData.projectTelegram || "",
      projectMedium: apiData.projectMedium || "",
      projectYoutube: apiData.projectYoutube || "",
      projectDiscord: apiData.projectDiscord || "",
      projectLinkedIn: apiData.projectLinkedIn || "",
    });

    // 5. Sale Rounds
    setSaleRounds(
      apiData.saleRounds?.length > 0
        ? apiData.saleRounds.map((round, index) => ({
            roundNumber: round.roundNumber || index + 1,
            roundPrice: round.roundPrice || 0,
            startDate: round.startDate || "",
            enddate: round.enddate || round.enddate || "",
          }))
        : [{ roundNumber: 1, roundPrice: 0, startDate: "", enddate: "" }]
    );

    // 6. Wallet Form Data
    setWalletFormData({
      projectFundWallet: apiData.projectFundWallet || "",
      platformFeeWallet: apiData.platformFeeWallet || "",
      ownerWallet: apiData.ownerWallet || "",
      buybackBurnWallet: apiData.buyBackBurnWallett || "",
      acceptedPaymentTokens: apiData.allowedTokens || [],
      platformFeeThreshold: apiData.platformFeeThreshold || "",
      initialPlatformAmount: apiData.initialPlatformAmount || "",
    });

    // 7. NFT Form Data
    setNftFormData({
      nftRequired: apiData.nftRequired || false,
      nftDetails: apiData.nftDetails || [],
      buyBackRequired: apiData.buyBack || false, // Note: API uses "buyBack"
      buyBackDetails: apiData.buyBackDetails || [],
    });
  };

  // Contract Calls
  // Helper function to get token addresses from IDs
  const getTokenAddressesFromIds = (tokenIds, tokensData) => {
    return tokenIds
      .map((tokenId) => {
        const token = tokensData.find((t) => t._id === tokenId);
        return token?.tokenContractAddress; // ✅ Correct property name
      })
      .filter(Boolean); // Remove any undefined/null values
  };

  const [tempCont, setTempCont] = useState("");

  const publishProject = async () => {
    const Envi = {
      staking: "0x034f504F34330eA87dcc8aBae2935eac9fD2eFaE",
      subscription: "0xe7Ad3a7EC2fdc8aa141dB9AFc1f701AAb579DA85",
    };

    const tokenAddresses = getTokenAddressesFromIds(
      walletformData.acceptedPaymentTokens,
      tokens // Pass your tokens state
    );

    console.log("Token Addresses:", tokenAddresses, tokens);
    const formData = {
      walletformData,
      nftFormData,
      saleRounds,

      // These need to be provided - get from your backend or config
      tokenAddresses,
      signerAddress: account, // Your signer address
      lockupContractAddress: Envi?.staking, // Lockup contract address
      subscriptionContractAddress: Envi?.subscription, // Subscription contract address
    };
    setLoader(true);
    // return console.log("initMaxCapinitMaxCap", walletformData);
    const tx = await createLaunchpad(account, formData, setLoader);
    if (tx) {
      const launchPadCreatedEvent = tx.events.LaunchPadCreated;
      const returnValues = launchPadCreatedEvent.returnValues;
      console.log(
        "tx.events.LaunchPadCreated",
        tx.events,
        tx.events.LaunchPadCreated
      );
      console.log("returnValues", returnValues);
      const preSaleContract = returnValues[1] || returnValues.presale;
      const claimContract = returnValues[2] || returnValues.claim;
      const index = returnValues[0] || returnValues.index;
      setTempCont(returnValues[1] || returnValues.presale);
      console.log(
        "preSaleContract, claimContract, index",
        preSaleContract,
        claimContract,
        index
      );
      goingLive(preSaleContract, claimContract, index);
    }
  };

  const goingLive = async (preSaleContract, claimContract, index) => {
    setLoader(true);
    let token = localStorage.getItem("accessToken");
    const hasProjectDocuments =
      Array.isArray(projectSetup?.documents?.value) &&
      projectSetup.documents.value.some((doc) => doc.file);
    let localProjectSetup = undefined;

    if (hasProjectDocuments) {
      localProjectSetup = {
        ...projectSetup,
        // transform documents
        documents: {
          ...projectSetup.documents,
          value: projectSetup.documents.value.map(
            ({ name, file2, file, ...rest }) => ({
              ...rest,
              title: rest.title || name || "",
              url: file || null, // convert file to url
              // file2 is removed automatically
            })
          ),
        },
        // transform projectMedia to array of objects with title and url
        projectMedia: {
          ...projectSetup.projectMedia,
          value: projectSetup.projectMedia.value
            .filter((item) => item.url) // Only include successfully uploaded items
            .map(({ title, url }) => ({ title, url })), // 👈 Keep both title and url
        },
      };
    }
    let localTeamData = undefined;

    // Check if there are valid team members
    const hasValidTeamMembers = teamFormData.team.some(
      (member) =>
        member.name.trim() !== "" ||
        member.designation.trim() !== "" ||
        member.bio.trim() !== "" ||
        member.image !== null
    );

    if (hasValidTeamMembers) {
      localTeamData = {
        team: teamFormData.team
          .filter(
            (member) =>
              member.name.trim() !== "" ||
              member.designation.trim() !== "" ||
              member.bio.trim() !== "" ||
              member.image !== null
          )
          .map(({ image, name, designation, bio, ...rest }) => {
            const teamMember = {
              ...rest,
              Name: name, // Transform to capital N
              designation,
              bio,
            };

            // Only add image if it's not null
            if (image !== null) {
              teamMember.image = image;
            }

            return teamMember;
          }),
      };
    }

    let saleRoundsPayload = undefined;

    // Only create if we have rounds and all are valid
    if (saleRounds.length > 0) {
      const allValid = saleRounds.every(
        (round) =>
          round.roundNumber > 0 &&
          round.roundPrice &&
          parseFloat(round.roundPrice) > 0 &&
          round.startDate &&
          round.startDate.trim() !== "" &&
          round.enddate &&
          round.enddate.trim() !== "" &&
          new Date(round.enddate) > new Date(round.startDate)
      );

      if (allValid) {
        saleRoundsPayload = saleRounds.map(
          ({ roundNumber, roundPrice, startDate, enddate }) => ({
            roundNumber,
            roundPrice: parseFloat(roundPrice),
            startDate,
            enddate: enddate,
          })
        );
      }
    }

    let localNftDetails = undefined;

    if (nftFormData.nftRequired) {
      // Check if all NFT details are complete
      const allNftDetailsComplete = nftFormData.nftDetails.every(
        (nft) =>
          nft.image &&
          nft.price &&
          nft.price.toString().trim() !== "" &&
          !isNaN(parseFloat(nft.price)) &&
          parseFloat(nft.price) > 0
      );

      // Only set localNftDetails if all details are complete
      if (allNftDetailsComplete && nftFormData.nftDetails.length > 0) {
        localNftDetails = {
          nftRequired: true,
          nftDetails: nftFormData.nftDetails.map((nft) => ({
            image: nft.image,
            price: parseFloat(nft.price),
          })),
        };
      }
      // If incomplete, localNftDetails remains undefined
    } else {
      // If nftRequired is false, include it in the payload
      localNftDetails = {
        nftRequired: false,
        nftDetails: [],
      };
    }

    const initialPlatformAmount = parseFloat(
      walletformData.initialPlatformAmount || "0"
    );
    const feeThreshold = parseFloat(
      walletformData?.platformFeeThreshold || "0"
    );

    let contractType = undefined;
    if (initialPlatformAmount === 0 && feeThreshold === 0) {
      contractType = "v0"; // Scenario 1: Standard
    } else if (initialPlatformAmount === 0 && feeThreshold > 0) {
      contractType = "v1"; // Scenario 2: Prepaid fee + threshold
    } else if (initialPlatformAmount > 0 && feeThreshold === 0) {
      contractType = "v2"; // Scenario 3: Platform takes first amount
    } else if (initialPlatformAmount > 0 && feeThreshold > 0) {
      contractType = "v2"; // Scenario 3 with both values (or could be a different round)
    }

    let data = JSON.stringify({
      projectName:
        basicInfo?.projectName?.value !== ""
          ? basicInfo?.projectName?.value
          : undefined,
      projectTicker:
        basicInfo?.projectTicker?.value !== ""
          ? basicInfo?.projectTicker?.value
          : undefined,
      projectShortDescription:
        basicInfo?.shortDescription?.value !== ""
          ? basicInfo?.shortDescription?.value
          : undefined,
      projectDetails:
        basicInfo?.details?.value !== ""
          ? basicInfo?.details?.value
          : undefined,
      projectImage: projectSetup?.projectImage?.value
        ? projectSetup?.projectImage?.value
        : undefined,
      projectBannerDesktop: projectSetup?.projectBannerDesktop?.value
        ? projectSetup?.projectBannerDesktop?.value
        : undefined,
      projectBannerMobile: projectSetup?.projectBannerMobile?.value
        ? projectSetup?.projectBannerMobile?.value
        : undefined,
      tokenomicsChartDark: projectSetup?.tokenomicsChartDark?.value
        ? projectSetup?.tokenomicsChartDark?.value
        : undefined,
      tokenomicsChartLight: projectSetup?.tokenomicsChartLight?.value
        ? projectSetup?.tokenomicsChartLight?.value
        : undefined,
      youtubeEmbed: projectSetup?.youtubeEmbeds?.value?.some(
        (url) => url.trim() !== ""
      )
        ? projectSetup.youtubeEmbeds.value
        : undefined,
      projectMedia: localProjectSetup?.projectMedia?.value,
      projectDocument: hasProjectDocuments
        ? localProjectSetup?.documents?.value
        : undefined,
      team: localTeamData?.team ? localTeamData?.team : localTeamData,
      saleRounds: saleRoundsPayload,
      projectWebsite:
        socialsFormData?.projectWebsite !== ""
          ? socialsFormData?.projectWebsite
          : undefined,
      projectTwitter:
        socialsFormData?.projectTwitter !== ""
          ? socialsFormData?.projectTwitter
          : undefined,
      projectTelegram:
        socialsFormData?.projectTelegram !== ""
          ? socialsFormData?.projectTelegram
          : undefined,
      projectMedium:
        socialsFormData?.projectMedium !== ""
          ? socialsFormData?.projectMedium
          : undefined,
      projectYoutube:
        socialsFormData?.projectYoutube !== ""
          ? socialsFormData?.projectYoutube
          : undefined,
      projectDiscord:
        socialsFormData?.projectDiscord !== ""
          ? socialsFormData?.projectDiscord
          : undefined,
      projectLinkedIn:
        socialsFormData?.projectLinkedIn !== ""
          ? socialsFormData?.projectLinkedIn
          : undefined,
      projectFundWallet:
        walletformData?.projectFundWallet !== ""
          ? walletformData?.projectFundWallet
          : undefined,
      platformFeeWallet:
        walletformData?.platformFeeWallet !== ""
          ? walletformData?.platformFeeWallet
          : undefined,
      ownerWallet:
        walletformData?.ownerWallet !== ""
          ? walletformData?.ownerWallet
          : undefined,
      buyBackBurnWallett:
        walletformData?.buybackBurnWallet !== ""
          ? walletformData?.buybackBurnWallet
          : undefined,
      allowedTokens:
        walletformData?.acceptedPaymentTokens?.length > 0
          ? walletformData?.acceptedPaymentTokens
          : undefined,
      platformFeeThreshold:
        walletformData?.platformFeeThreshold !== ""
          ? walletformData?.platformFeeThreshold
          : undefined,
      initialPlatformAmount:
        walletformData?.initialPlatformAmount !== ""
          ? walletformData?.initialPlatformAmount
          : undefined,
      nftRequired: localNftDetails?.nftRequired,
      buyBack: nftFormData?.buyBackRequired,
      nftDetails: localNftDetails?.nftDetails,
      stage: currentStep + 1,
      id: projectId ? projectId : undefined,
      isLive: true,
      preSaleContract,
      claimContract,
      index,
      contractVersion: contractType,
    });

    let config = {
      method: projectId ? "patch" : "post",
      maxBodyLength: Infinity,
      url: `${Api_Url}/pro-projects/${projectId ? "update" : "create"}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        localStorage?.removeItem("draftProjectId");
        handleShow1();
        console.log(JSON.stringify(response.data));
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(tempCont).then(() => {
      setCopied(true);

      // Optional: revert back to original SVG after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    });
  };

  useEffect(() => {
    if (tokens?.length === 0) {
      let token = localStorage?.getItem("accessToken");

      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${Api_Url}/dynamic-tokens/all?limit=10&offset=1&orderField=createdAt&orderDirection=1`,
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      axios
        .request(config)
        .then((response) => {
          setTokens(response?.data?.data?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  return (
    <>
      {loader && <Loader />}
      {changeRoute ? (
        <PreviewProject
          setRoutes={setRoutes}
          basicInfo={basicInfo}
          setBasicInfo={setBasicInfo}
          walletformData={walletformData}
          teamFormData={teamFormData}
          projectSetup={projectSetup}
          saleRounds={saleRounds}
          setLoader={setLoader}
          socialsFormData={socialsFormData}
          nftFormData={nftFormData}
          setLastUpdated={setLastUpdated}
          currentStep={currentStep}
          projectId={projectId}
          lastUpdated={lastUpdated}
          setChangeRoute={setChangeRoute}
          setProjectSetup={setProjectSetup}
          setSocialsFormData={setSocialsFormData}
          setTeamFormData={setTeamFormData}
          isLive={isLive}
          setIsLive={setIsLive}
          setId={setId}
          isAvailable={isAvailable}
          setProjectId={setProjectId}
        />
      ) : (
        <>
          <section className="createproject">
            <img src="\assets\shadow.png" className="shaddow" />
            <h1 className="createname">Create Premium project</h1>
            <div className="createmain">
              <div className="createleft">
                {steps.map((step, index) => {
                  const isActive = index === currentStep;
                  const isCompleted = index < currentStep;

                  return (
                    <div
                      key={index}
                      className={`stepmain 
                  ${isActive ? "active" : ""} 
                  ${isCompleted ? "completed" : ""}
                `}
                    >
                      <div className="stepinnermain">
                        <div className="stepinner">
                          {isCompleted ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="11"
                              height="11"
                              viewBox="0 0 11 11"
                              fill="none"
                            >
                              <path
                                d="M11 4.41681L11 0L4.10844 6.7126L0 3.88235L3.66271e-07 7.97707L4.10843 11L11 4.41681Z"
                                fill="white"
                              />
                            </svg>
                          ) : (
                            index + 1
                          )}
                        </div>
                        {index !== steps.length - 1 && (
                          <span className="line"></span>
                        )}
                      </div>
                      <p className="steppara">{step.title}</p>
                    </div>
                  );
                })}
                <div className="stepsmbl d-none">
                  <p className="titlepara">{steps[currentStep].title}</p>
                  <h6 className="titlehead">
                    <span className="black">{currentStep + 1}</span>
                    /8
                  </h6>
                </div>
              </div>
              <ProgressBar
                now={progressPercent}
                className="stepsprogress d-none"
              />
              <div className="createright">
                <div className="createheader">
                  <h1 className="createhead">project setup</h1>
                </div>
                <div className="createbody">{steps[currentStep].component}</div>
                <div className="createbtns">
                  {currentStep > 0 && (
                    <button
                      className="backbtn"
                      onClick={handleBack}
                      disabled={currentStep === 0}
                    >
                      Back
                    </button>
                  )}

                  {currentStep === 3 && (
                    <button
                      className="previewbtn"
                      onClick={() => {
                        setChangeRoute(true);
                      }}
                    >
                      Preview
                    </button>
                  )}

                  {currentStep === steps.length - 1 ? (
                    <button
                      className="publishbtn"
                      onClick={() => {
                        handleShow(); // call the function
                      }}
                    >
                      Publish & Exit
                    </button>
                  ) : (
                    <button className="nextbtn" onClick={handleNext}>
                      Next
                    </button>
                  )}
                </div>
                {/* <p style={{ color: "red", textAlign: "center", fontSize: 12 }}>
                  {isConnected}
                </p> */}
              </div>
            </div>
          </section>
          <Bottompage
            setRoutes={setRoutes}
            basicInfo={basicInfo}
            walletformData={walletformData}
            teamFormData={teamFormData}
            projectSetup={projectSetup}
            saleRounds={saleRounds}
            setLastUpdated={setLastUpdated}
            setLoader={setLoader}
            socialsFormData={socialsFormData}
            nftFormData={nftFormData}
            currentStep={currentStep}
            projectId={projectId}
            lastUpdated={lastUpdated}
            setId={setId}
            setChangeRoute={setChangeRoute}
            isAvailable={isAvailable}
            setProjectId={setProjectId}
          />
        </>
      )}
      <Modal
        className="publish-modall"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="publish_modal">
            <div className="inner_publish">
              <h3>Confirm Project Publication</h3>
              <p>You are about to deploy a smart contract.</p>
              <p>This action is irreversible. Once published:</p>
              <ul>
                <li>The smart contract will be deployed to the blockchain</li>
                <li>
                  Project information cannot be completely removed, only project
                  details page will be editable.
                </li>
                <li>
                  Contract address will be permanently associated with this
                  project{" "}
                </li>
              </ul>
              <p>Are you sure you want to proceed?</p>
            </div>
            <div className="publish_buttons">
              <button onClick={handleClose} className="cancel_button">
                Cancel
              </button>
              <button
                className="confirm_button"
                onClick={() => {
                  publishProject();
                  handleClose();
                }}
              >
                Confirm & Publish
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="publish-modall"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="publish_modal">
            <div className="success_modal">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
              >
                <path
                  d="M39.9999 77.8949C60.9286 77.8949 77.8946 60.9289 77.8946 40.0002C77.8946 19.0715 60.9286 2.10547 39.9999 2.10547C19.0712 2.10547 2.10516 19.0715 2.10516 40.0002C2.10516 60.9289 19.0712 77.8949 39.9999 77.8949Z"
                  fill="#329879"
                />
                <path
                  d="M36.1263 54.4C35.579 54.4 35.0316 54.1894 34.6526 53.7684L22.9474 42.0631C22.1053 41.221 22.1053 39.9157 22.9474 39.0736C23.7895 38.2315 25.0947 38.2315 25.9368 39.0736L36 49.1368L54.0211 26.4C54.7369 25.4736 56.0842 25.3473 56.9684 26.0631C57.8947 26.7789 58.0211 28.1263 57.3053 29.0105L37.8105 53.6C37.4316 54.0631 36.8842 54.3579 36.2947 54.4C36.2105 54.4 36.1684 54.4 36.1263 54.4Z"
                  fill="#E2E9EC"
                />
              </svg>
              <h4>Project Published Successfully!</h4>
              <p>Your project is now live on Gems Launchpad.</p>
              <div className="lower_Div">
                <h5>Contract Address</h5>
                <div className="textual__Div">
                  <h6>{tempCont} </h6>
                  <span onClick={handleCopy} style={{ cursor: "pointer" }}>
                    {copied ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#329879"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                    ) : (
                      <svg
                        className="copiedsvg"
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M15.1875 1.96875H6.1875C5.96372 1.96875 5.74911 2.05764 5.59088 2.21588C5.43264 2.37411 5.34375 2.58872 5.34375 2.8125V5.34375H2.8125C2.58872 5.34375 2.37411 5.43264 2.21588 5.59088C2.05764 5.74911 1.96875 5.96372 1.96875 6.1875V15.1875C1.96875 15.4113 2.05764 15.6259 2.21588 15.7841C2.37411 15.9424 2.58872 16.0312 2.8125 16.0312H11.8125C12.0363 16.0312 12.2509 15.9424 12.4091 15.7841C12.5674 15.6259 12.6562 15.4113 12.6562 15.1875V12.6562H15.1875C15.4113 12.6562 15.6259 12.5674 15.7841 12.4091C15.9424 12.2509 16.0312 12.0363 16.0312 11.8125V2.8125C16.0312 2.58872 15.9424 2.37411 15.7841 2.21588C15.6259 2.05764 15.4113 1.96875 15.1875 1.96875ZM10.9688 14.3438H3.65625V7.03125H10.9688V14.3438ZM14.3438 10.9688H12.6562V6.1875C12.6562 5.96372 12.5674 5.74911 12.4091 5.59088C12.2509 5.43264 12.0363 5.34375 11.8125 5.34375H7.03125V3.65625H14.3438V10.9688Z"
                          fill="#329879"
                        />
                      </svg>
                    )}
                  </span>
                </div>
              </div>
            </div>
            <div className="publish_buttons">
              <button className="confirm_button" onClick={handleClose1}>
                Go to All Projects
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="publish-modall"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Failed</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="publish_modal">
            <div className="success_modal">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M40 78.5C44.9902 78.5 49.9316 77.5171 54.542 75.6074C59.1523 73.6977 63.3414 70.8987 66.87 67.37C70.3987 63.8414 73.1977 59.6523 75.1074 55.042C77.0171 50.4316 78 45.4902 78 40.5C78 35.5098 77.0171 30.5684 75.1074 25.958C73.1977 21.3477 70.3987 17.1586 66.87 13.6299C63.3414 10.1013 59.1523 7.30226 54.542 5.39258C49.9316 3.4829 44.9902 2.5 40 2.5C29.9218 2.5 20.2563 6.50356 13.1299 13.6299C6.00356 20.7563 2 30.4218 2 40.5C2 50.5782 6.00356 60.2437 13.1299 67.37C20.2563 74.4964 29.9218 78.5 40 78.5Z"
                  fill="#FC4F52"
                />
                <path
                  d="M55 25L25 55"
                  stroke="white"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M25 25L55 55"
                  stroke="white"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <h4>
                Smart Contract <br></br> Deployment Failed
              </h4>
              <p>The project has been saved as a draft.</p>
            </div>
            <div className="publish_buttons">
              <button className="cancel_button" onClick={handleClose2}>
                Go to Draft Projects
              </button>
              <button className="confirm_button" onClick={handleClose2}>
                Retry
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Createpremiumprojects;
